const scaleSpring = {
  type: 'spring',
  stiffness: 700,
  damping: 25,
  mass: 1,
}

const tween150 = { type: 'tween', duration: 0.15 }

/** Motion gesture props for list add / done / modal primary buttons (replaces react-pose listMainButtonPose). */
export const listMainButtonMotionProps = {
  initial: { scale: 1, y: 0 },
  whileHover: {
    scale: 1.05,
    y: 0,
    transition: { scale: scaleSpring, y: tween150 },
  },
  whileTap: {
    scale: 0.85,
    y: 0,
    transition: { scale: scaleSpring },
  },
  transition: { scale: tween150, y: tween150 },
}
